var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Abstract/08",
    transform: "translate(-4.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-55",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,4 C12.568,4 11,5.568 11,7.5 C11,9.432 12.568,11 14.5,11 C16.432,11 18,9.432 18,7.5 C18,5.568 16.432,4 14.5,4",
    id: "Fill-5",
    fill: "#9AE0EA",
    className: "fill-dynamic-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,13 C2.894,13 2,13.894 2,15 C2,16.104 2.894,17 4,17 C5.106,17 6,16.104 6,15 C6,13.894 5.106,13 4,13",
    id: "Fill-7",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,14 C30,12.894 29.106,12 28,12 C26.894,12 26,12.894 26,14 C26,15.104 26.894,16 28,16 C29.106,16 30,15.104 30,14",
    id: "Fill-9",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,6 C25.106,6 26,5.104 26,4 C26,2.894 25.106,2 24,2 C22.894,2 22,2.894 22,4 C22,5.104 22.894,6 24,6",
    id: "Fill-11",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,17 C35,18.104 35.894,19 37,19 C38.106,19 39,18.104 39,17 C39,15.894 38.106,15 37,15 C35.894,15 35,15.894 35,17",
    id: "Fill-13",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5,0 C33.568,0 32,1.568 32,3.5 C32,5.432 33.568,7 35.5,7 C37.432,7 39,5.432 39,3.5 C39,1.568 37.432,0 35.5,0",
    id: "Fill-15",
    fill: "#9AE0EA",
    className: "fill-dynamic-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,9 C41.894,9 41,9.894 41,11 C41,12.104 41.894,13 43,13 C44.106,13 45,12.104 45,11 C45,9.894 44.106,9 43,9",
    id: "Fill-17",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,40 C44,38.894 43.106,38 42,38 C40.894,38 40,38.894 40,40 C40,41.104 40.894,42 42,42 C43.106,42 44,41.104 44,40",
    id: "Fill-19",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,22 C41.894,22 41,22.894 41,24 C41,25.104 41.894,26 43,26 C44.106,26 45,25.104 45,24 C45,22.894 44.106,22 43,22",
    id: "Fill-21",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,43 C54,41.894 53.106,41 52,41 C50.894,41 50,41.894 50,43 C50,44.104 50.894,45 52,45 C53.106,45 54,44.104 54,43",
    id: "Fill-23",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,23 C1.568,23 0,24.568 0,26.5 C0,28.432 1.568,30 3.5,30 C5.432,30 7,28.432 7,26.5 C7,24.568 5.432,23 3.5,23",
    id: "Fill-25",
    fill: "#9AE0EA",
    className: "fill-dynamic-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,56 C19.432,56 21,54.432 21,52.5 C21,50.568 19.432,49 17.5,49 C15.568,49 14,50.568 14,52.5 C14,54.432 15.568,56 17.5,56",
    id: "Fill-29",
    fill: "#9AE0EA",
    className: "fill-dynamic-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5,56 C42.432,56 44,54.432 44,52.5 C44,50.568 42.432,49 40.5,49 C38.568,49 37,50.568 37,52.5 C37,54.432 38.568,56 40.5,56",
    id: "Fill-31",
    fill: "#EEBAD4",
    className: "fill-dynamic-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,28.5 C36,26.568 34.432,25 32.5,25 C30.568,25 29,26.568 29,28.5 C29,30.432 30.568,32 32.5,32 C34.432,32 36,30.432 36,28.5",
    id: "Fill-37",
    fill: "#9AE0EA",
    className: "fill-dynamic-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,36.5 C22,34.568 20.432,33 18.5,33 C16.568,33 15,34.568 15,36.5 C15,38.432 16.568,40 18.5,40 C20.432,40 22,38.432 22,36.5",
    id: "Fill-39",
    fill: "#9AE0EA",
    className: "fill-dynamic-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5,28 C50.568,28 49,29.568 49,31.5 C49,33.432 50.568,35 52.5,35 C54.432,35 56,33.432 56,31.5 C56,29.568 54.432,28 52.5,28",
    id: "Fill-41",
    fill: "#9AE0EA",
    className: "fill-dynamic-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,18 C16.568,18 15,19.568 15,21.5 C15,23.432 16.568,25 18.5,25 C20.432,25 22,23.432 22,21.5 C22,19.568 20.432,18 18.5,18",
    id: "Fill-45",
    fill: "#EEBAD4",
    className: "fill-dynamic-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5,21 C52.432,21 54,19.432 54,17.5 C54,15.568 52.432,14 50.5,14 C48.568,14 47,15.568 47,17.5 C47,19.432 48.568,21 50.5,21",
    id: "Fill-47",
    fill: "#EEBAD4",
    className: "fill-dynamic-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,37 C2.894,37 2,37.894 2,39 C2,40.104 2.894,41 4,41 C5.106,41 6,40.104 6,39 C6,37.894 5.106,37 4,37",
    id: "Fill-49",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,47 C12.106,47 13,46.104 13,45 C13,43.894 12.106,43 11,43 C9.894,43 9,43.894 9,45 C9,46.104 9.894,47 11,47",
    id: "Fill-51",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,45 C32.106,45 33,44.104 33,43 C33,41.894 32.106,41 31,41 C29.894,41 29,41.894 29,43 C29,44.104 29.894,45 31,45",
    id: "Fill-53",
    className: "icon-color-base"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon08);
export default __webpack_public_path__ + "static/media/icon08.54f08bd9771bed8adfb4f2ea6ed23225.svg";
export { ForwardRef as ReactComponent };